import { useEffect } from 'react';
import { usePostHog } from 'posthog-js/react';
import {
  getGravityUserId,
  getGravityUserOrgId,
  getGravityUserPlan,
} from './useAuth';

export const usePostHogIdentify = (): void => {
  const posthog = usePostHog();

  useEffect(() => {
    if (!posthog) return;

    const distinctId = getGravityUserId()?.trim();
    if (!distinctId) return;

    const plan = getGravityUserPlan();
    const orgId = getGravityUserOrgId();

    posthog.identify(distinctId, {
      plan: plan || undefined,
      orgId: orgId || undefined,
    });
  }, [posthog]);
};
